export default "__VITE_ASSET__ChDPEzlJ__"